import { SET_RUNNING, SET_POPUP_STATUS } from '../actions/type'

const initialState = {
    spinner: false,
    popupStatus: {
        isShow: false,
        status: '',
        header: '',
        body: '',
        action: null
    }
}

const backgroundRunning = (state = initialState, action) => {
    switch (action.type) {
        case SET_RUNNING: {
            const payload = action.payload
            return { ...state, ...payload }
        }
        case SET_POPUP_STATUS: {
            const payload = action.payload;
            return { ...state, popupStatus: { ...payload } }
        }
        default:
            return state
    }
}

export default backgroundRunning